import React from "react";
import { Col, Container, Row } from "reactstrap";
import showdown from 'showdown';
import CallToButton from "../components/CallToButton";
import ContactForm from "../components/contactform";
import Grid9Img from "../components/Grid9Img";
import Metadata from "../components/Metadata";

const converter = new showdown.Converter();

const LandingKuechenplattenPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;
  const teaserImageStyle = {
    width: '100%',
    marginTop: '55px'
  }

  return (
    <Container className="body__main">
      <Metadata
        title={frontmatter.title}
        description={frontmatter.description}
      />
      <Row>

          <Col>
            <h1 id="heading" className="mainheader">{frontmatter.heading}</h1>
          </Col>
      </Row>
      {/* <FullPageImg image1={frontmatter.banner1.image1} /> */}
      <Row className="mb-4">
        <Col md="6">
          <ContactForm></ContactForm>
        </Col>
          <Col md="6">
            <img style={teaserImageStyle} src={frontmatter.banner1.image1.image} />
          </Col>
      </Row>
      <Row className="mt-4">
          <Col>
          <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(frontmatter.bodycopy1) }} />
          </Col>
      </Row>
      <CallToButton link="/lp-kupl/#heading" linktext={frontmatter.calltobutton1} />
        <Grid9Img
          image1={frontmatter.grid1.image1}
          image2={frontmatter.grid1.image2}
          image3={frontmatter.grid1.image3}
          image4={frontmatter.grid1.image4}
          image5={frontmatter.grid1.image5}
          image6={frontmatter.grid1.image6}
          image7={frontmatter.grid1.image7}
          image8={frontmatter.grid1.image8}
          image9={frontmatter.grid1.image9}
        />
      <Row className="mt-4">
          <Col>
          <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(frontmatter.bodycopy2) }} />
          </Col>
      </Row>
      <br />
      <CallToButton link="/lp-kupl/#heading" linktext={frontmatter.calltobutton2} />
      <Row className="mt-4">
          <Col>
          <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(frontmatter.bodycopy3) }} />
          </Col>
      </Row>
      <CallToButton link="/lp-kupl/#heading" linktext={frontmatter.calltobutton3} />
    </Container>
  );
};

export default LandingKuechenplattenPage;

export const LandingKuechenplattenPageQuery = graphql`
  query LandingKuechenplattenPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        templateKey
        title
        heading
        description
        calltobutton1
        calltobutton2
        calltobutton3
        bodycopy1
        bodycopy2
        bodycopy3
        grid1 {
          image1 {
            image
          }
          image2 {
            image
          }
          image3 {
            image
          }
          image4 {
            image
          }
          image5 {
            image
          }
          image6 {
            image
          }
          image7 {
            image
          }
          image8 {
            image
          }
          image9 {
            image
          }
        }
        banner1 {
          image1 {
            image
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/landingkuechenplatten-page.js